export const TrackEnum = {
  AberturaLink: 200,
  PagamentoEfetuado: 201,
  OrcamentoInvalido: 300,
  ContratoGerado: 301,
  OrcamentoNaoAutorizado: 302,
  NumeroCartaoBandeiraInvalido: 303,
  ValorMaximoParcelasInvalido: 304,
  ErroServidor: 400,
  RetornoAPI: 401,
};
